import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Box, Grid, Backdrop, Typography, CircularProgress } from "@material-ui/core";

import "./AppLayout.css";

import select from "../../utils/select";
import ROUTER from "../../constants/router";
import Sidebar from "../../containers/AppLayout/Sidebar";
import AppHeader from "../../containers/AppLayout/AppHeader";
import AppFooter from "../../containers/AppLayout/AppFooter";

import Home from "../Home";
import User from "../User";
import Work from "../Work";
import Search from "../Search";
import Conference from "../Conference";
import Management from "../Management";
import Department from "../Department";
import AdminSetting from "../AdminSetting";
import Construction from "../Construction/Construction";
import HumanResource from "../HumanResource";
import EmploymentContract from "../EmploymentContract";
import NotificationScreen from "../NotificationScreen";
import Document from "../Document"; // [VinUni] Module 8 - Quản lý văn bản
import RaContract from "../RaContract"; // [VinUni] Module 6 - Hợp đồng TLNC (RA)
import ResearchTopic from "../ResearchTopic"; // [VinUni] Quản lý đề tài
// [VinUni] Các module sau không thuộc 8 module ưu tiên -> tạm ẩn (giữ code, mở lại khi cần)
// import Report from "../Report";                       // Báo cáo giờ nghiên cứu
// import RewardManagement from "../RewardManagement";   // Tính thưởng
// import StudentProject from "../StudentProject";       // NCKH sinh viên
// import StudentProjectCouncil from "../StudentProjectCouncil";
// import InstitutionalProject from "../InstitutionalProject"; // NCKH cơ sở

// [VinUni] Tạm ẩn route NCKH sinh viên (giữ code)
// function StudentProjectRoute() {
//   const { path } = useRouteMatch();
//
//   return (
//     <Switch>
//       <Route exact path={`${path}/personal`}>
//         <StudentProject type="personal" />
//       </Route>
//       <Route exact path={`${path}/admin`}>
//         <StudentProject type="admin" />
//       </Route>
//       <Route exact path={`${path}/mod`}>
//         <StudentProject type="mod" />
//       </Route>
//       <Route exact path={`${path}/council`}>
//         <StudentProjectCouncil />
//       </Route>
//       <Route exact path={`${path}/conference`}>
//         <StudentProject type="conference" />
//       </Route>
//     </Switch>
//   );
// }

// [VinUni] Tạm ẩn route NCKH cơ sở (giữ code)
// function InstitutionalProjectRoute() {
//   const { path } = useRouteMatch();
//
//   return (
//     <Switch>
//       <Route exact path={`${path}/personal`}>
//         <InstitutionalProject type="personal" />
//       </Route>
//       <Route exact path={`${path}/admin`}>
//         <InstitutionalProject type="admin" />
//       </Route>
//       <Route exact path={`${path}/mod`}>
//         <InstitutionalProject type="mod" />
//       </Route>
//     </Switch>
//   );
// }

function AppLayout() {
  const [animText, setAnimText] = useState(true);
  const [open, setOpen] = useState(localStorage.getItem("side-bar-open") === "true");

  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));

  const url = window.location.href;
  const isGuestRoute = url.split("/").slice(-1)[0].toLowerCase().includes("guest");

  // console.log("profileDetail", profileDetail, isGuestRoute);

  useEffect(() => localStorage.setItem("side-bar-open", open), [open]);

  return (
    <Box style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Sidebar open={open} animText={animText} setOpen={setOpen} style={{ position: "fixed" }} />

      {/* Header cố định */}
      <Box
        style={{
          position: "fixed",
          top: 0,
          left: isGuestRoute && !profileDetail ? 0 : open ? 250 : 80,
          right: 0,
          zIndex: 1100,
          transition: "0.5s",
        }}
      >
        <AppHeader open={open} setOpen={setOpen} setAnimText={setAnimText} />
      </Box>

      {/* Main content area */}
      <Box
        style={{
          display: "flex",
          flex: 1,
          marginTop: 56, // Header height (32px + 2*8px margin + padding)
          marginBottom: 30, // Footer height
        }}
      >
        {/* Sidebar spacing */}
        <Box
          display={{ xs: "none", md: "flex" }}
          style={{
            transition: "0.5s",
            width: isGuestRoute && !profileDetail ? 0 : open ? 250 : 80,
            flexShrink: 0,
          }}
        />

        {/* Content */}
        <Box
          style={{
            flex: 1,
            overflow: "auto",
            padding: "0px 16px",
          }}
        >
          <Switch>
            <Route path={ROUTER.WORK} component={Work} />
            <Route path={ROUTER.SEARCH} component={Search} />
            <Route path={ROUTER.PHENIKAA_CONFERENCE} component={Construction} />
            <Route path={ROUTER.INTELLECTUAL_PROPERTY} component={Construction} />
            <Route path={ROUTER.CONFERENCE} component={Conference} />
            <Route path={ROUTER.MANAGEMENT} component={Management} />
            <Route path={ROUTER.DEPARTMENT} component={Department} />
            {/* [VinUni] Tạm ẩn route NCKH sinh viên / cơ sở (giữ code) */}
            {/* <Route path={ROUTER.NCKH_SINH_VIEN}>
              <StudentProjectRoute />
            </Route>
            <Route path={ROUTER.NCKH_CO_SO}>
              <InstitutionalProjectRoute />
            </Route> */}
            <Route path={ROUTER.USER} component={User} />
            <Route path={ROUTER.ADMIN_SETTING} component={AdminSetting} />
            <Route path={ROUTER.CONTRACT} component={RaContract} />
            <Route path={ROUTER.DOCUMENT} component={Document} />
            <Route path={ROUTER.RESEARCH_TOPIC} component={ResearchTopic} />{/* [VinUni] Quản lý đề tài */}
            {/* [VinUni] Tạm ẩn route Báo cáo giờ NC / Tính thưởng (giữ code) */}
            {/* <Route path={ROUTER.REPORT} component={Report} />
            <Route path={ROUTER.REWARD_MANAGEMENT} component={RewardManagement} /> */}
            <Route path={ROUTER.NOTIFICATION} component={NotificationScreen} />
            <Route path={ROUTER.HUMANRESOURCE} component={HumanResource} />
            <Route exact path={ROUTER.GUEST} component={Home} />
            <Route exact path={ROUTER.ORLAB_GUEST} component={Home} />
            <Route path={ROUTER.HOME} component={Home} />
          </Switch>
        </Box>
      </Box>

      <AppFooter open={open} profileDetail={profileDetail} />

      <Backdrop in={!isGuestRoute && !profileDetail} style={{ zIndex: 999999 }}>
        <Box id="loading">
          <CircularProgress />
          <Typography variant="body1">
            <b>Đang tải...</b>
          </Typography>
        </Box>
      </Backdrop>
    </Box>
  );
}

export default AppLayout;

